"use strict";

var GA4 = {
  HOST: 'https://www.google-analytics.com',
  endpoint: '/mp/collect',
  apiSecret: 'DMvuauovQ8yOTwO64N2_7g',
  measurementID: 'G-14SG8LDNNS',
  amount: undefined,
  transactionID: undefined,
  status: 'pending',
  onload: document.addEventListener('DOMContentLoaded', function () {
    GA4.init();
  }),
  init: function init() {},
  sendEvent: function sendEvent() {
    if (GA4.status === 'success') {
      var clientID = ga.getAll()[0].get('clientId');
      var requestData = {
        "client_id": clientID,
        "non_personalized_ads": false,
        "events": [{
          "name": "earn_virtual_currency",
          "params": {
            "transaction_id": GA4.transactionID,
            "virtual_currency_name": "EUR",
            "value": GA4.amount,
            "revenue": GA4.amount
          }
        }]
      };
      $.ajax({
        url: GA4.HOST + GA4.endpoint + '?api_secret=' + GA4.apiSecret + '&measurement_id=' + GA4.measurementID,
        type: 'POST',
        data: JSON.stringify(requestData),
        contentType: false,
        processData: false,
        success: function success(answer) {
          // todo
        }
      });
    }
  }
};